import { defineComponent as _defineComponent } from 'vue'
import Typography from '@/components/Rain/Typography/Typography.vue'

interface Props {
    isLoading: boolean
    codes: string[]
    fromMfaSetup: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MFASetupOk',
  props: {
    isLoading: { type: Boolean },
    codes: { default: Array as () => string[] },
    fromMfaSetup: { type: Boolean, default: false }
  },
  emits: ['onDownload', 'onDone'],
  setup(__props: any, { emit }) {

const props = __props as { isLoading: boolean, codes: string[], fromMfaSetup: boolean };





return { __sfc: true,props, emit, Typography }
}

})